<app-login-enduser *ngIf="!isUserAdmin && !isIntelligenceSuite && !isInventory"></app-login-enduser>
<app-login-admin *ngIf="isUserAdmin"></app-login-admin>
<app-intelligence-suite *ngIf="isIntelligenceSuite"></app-intelligence-suite>
<app-inventory-ui *ngIf="isInventory"></app-inventory-ui>
